import { HatApplicationContent } from '../../interfaces/hat-application.interface';

export const isOwnersApp = (application: HatApplicationContent): boolean => {
  return application.id.startsWith('hatapp');
};
